module.exports = __webpack_public_path__ + "img/mandiri.762da211.png";